import React from 'react'
import { Link } from 'gatsby'

import * as ROUTES from '../../../constants/routes'

import 'bootstrap/dist/css/bootstrap.min.css'
import FooterStyles from './footer.module.css'

export default function Footer() {
    return (
        <footer className={FooterStyles.footer}>
            <div className="d-flex flex-column-reverse justify-content-around ">
                <Link className={FooterStyles.logo} to={ROUTES.HOME}>
                    Feighmi
                </Link>

                <ul className={FooterStyles.nav}>
                    <li className="">
                        <Link className="" to={ROUTES.HOME}>
                            Home <span className="sr-only">Contact Us</span>
                        </Link>
                    </li>
                    <li className=" ">
                        <Link className="" to={ROUTES.ABOUT}>
                            About
                        </Link>
                    </li>
                    <li className=" ">
                        <Link className="" to={ROUTES.HOME}>
                            Advertise
                        </Link>
                    </li>
                </ul>

                <ul className={FooterStyles.followUs}>
                    <li className="">
                        <h2>Follow us</h2>
                    </li>
                    <li className=" ">
                        <a
                            className=""
                            href="https://www.facebook.com/110524243696660?referrer=whatsapp"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className="fa fa-facebook"></span>
                        </a>
                    </li>
                    <li className=" ">
                        <a
                            className=""
                            href="https://instagram.com/feighmi"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className="fa fa-instagram"></span>
                        </a>
                    </li>
                </ul>
            </div>
            <p className={FooterStyles.copyright}>
                {`© 2020 Feighmi Blog, `}
                <a
                    href="timiodulate.netlify.app"
                    target="_blank"
                    rel="noreferrer"
                >
                    timiodulate.
                </a>
                {` All rights reserved.`}
                {/* <span>All rights reserved.</span> */}
            </p>
        </footer>
    )
}
